import CreateLinksControl from '@office-start/create-links-control';
import React from 'react';
import styles from './CreateControl.module.scss';
export var CreateControl = function (_a) {
    var createLinkGroups = _a.createLinkGroups, createHeaderText = _a.createHeaderText, darkMode = _a.darkMode, useSvgIcons = _a.useSvgIcons;
    return (React.createElement("div", { className: styles['full-height'] },
        React.createElement(CreateLinksControl, { createLinkGroups: createLinkGroups, createHeaderText: createHeaderText, darkMode: darkMode, useSvgIcons: useSvgIcons })));
};
//# sourceMappingURL=CreateControl.js.map